module.exports = __webpack_public_path__ + "files/dd17495e9bc86b902db5f74ed2bc81b3.png";